<template>
  <section class="form__content">
    <h3>3. {{ $t('registration.title') }}</h3>

    <v-form v-model="formValidation">
      <v-text-field :label="$t('registrationErasmus.originEntity')"
                    :value="originEntity"
                    @input="$emit('update:originEntity', $event)"
                    aria-required="true"
      />

      <v-text-field :label="$t('registrationErasmus.registrationFaculty')"
                    :value="registrationFaculty"
                    @input="$emit('update:registrationFaculty', $event)"
                    aria-required="true"
      />

      <v-text-field :label="$t('registrationErasmus.registrationPersuedDegree')"
                    :value="registrationPersuedDegree"
                    @input="$emit('update:registrationPersuedDegree', $event)"
                    aria-required="true"
      />

      <v-radio-group :label="$t('registrationErasmus.exchangeProgram.label')"
                     :value="exchangeProgram"
                     @change="$emit('update:exchangeProgram', $event)"
      >
        <v-radio v-for="item in items"
                 :key="item.value"
                 :value="item.value"
                 :label="item.label"
        />
      </v-radio-group>

      <v-text-field v-if="exchangeProgram === 'ep-other' || exchangeProgram === 'ep-erasmusMundus'"
                    :label="$t('registrationErasmus.titleOther')"
                    :value="titleOther"
                    @input="$emit('update:titleOther', $event)"
                    aria-required="true"
      />
    </v-form>
  </section>
</template>

<script>
export default {
  name: 'registration',

  props: {
    valid: {
      required: true,
    },
    isLaw: {
      required: false,
      default: false,
    },
    originEntity: {
      required: true,
    },
    registrationFaculty: {
      required: true,
    },
    registrationPersuedDegree: {
      required: true,
    },
    titleOther: {
      required: true,
    },
    exchangeProgram: {
      required: true,
    },
  },

  data () {
    return {
      formValidation: false,
      items: [
        {
          label: this.$t('registrationErasmus.exchangeProgram.items.ep-erasmus'),
          value: 'ep-erasmus',
        },
        {
          label: this.$t('registrationErasmus.exchangeProgram.items.ep-erasmusMundus'),
          value: 'ep-erasmusMundus',
        },
        {
          label: this.$t('registrationErasmus.exchangeProgram.items.ep-interUAgreement'),
          value: 'ep-interUAgreement',
        },
        {
          label: this.$t('registrationErasmus.exchangeProgram.items.ep-other'),
          value: 'ep-other',
        },
      ],
    }
  },

  created () {
    if (this.isLaw) {
      this.items = [
        {
          label: this.$t('registrationErasmus.exchangeProgram.items.ep-erasmus'),
          value: 'ep-erasmus',
        },
        {
          label: this.$t('registrationErasmus.exchangeProgram.items.ep-interUAgreement'),
          value: 'ep-interUAgreement',
        },
      ]
    }
  },

  computed: {
    hasRegistrationEntitiesList () {
      return this.registrationEntitiesList === null
    },
  },

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
  },
}
</script>
